import InputStyles from 'admin-components/styles/input';
import styled from 'styled-components';

const Input = styled.input.attrs(({ placeHolder }) => ({
  placeholder: placeHolder
}))`
  ${InputStyles};
`;

export default Input;
